import React from 'react';
import Icons from '../../../components/Icons/Icons';
import Slider from 'react-slick';
import autographIcon from '../../LandingPage/Assets/autographs.png';
import appearancesIcon from '../../LandingPage/Assets/appearances.png';
import shoutoutIcon from '../../LandingPage/Assets/shoutout.png';
import creativeMediaIcon from '../../LandingPage/Assets/mentorship (1).svg';

import css from './Sections.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import { FormattedMessage } from 'react-intl';

export const getSignatureServices = intl => [
  {
    icon: autographIcon,
    isImage: true,
    key: 'autographs',
    title: intl.formatMessage({ id: 'ExploreServices.Autographs.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Autographs.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Autographs.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: shoutoutIcon,
    isImage: true,
    key: 'shoutouts',
    title: intl.formatMessage({ id: 'ExploreServices.Shoutouts.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Shoutouts.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Shoutouts.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: 'package',
    key: 'endorsements',
    title: intl.formatMessage({ id: 'ExploreServices.Endorsements.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Endorsements.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Endorsements.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: appearancesIcon,
    isImage: true,
    key: 'appearances',
    title: intl.formatMessage({ id: 'ExploreServices.MeetAndGreets.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.MeetAndGreets.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.MeetAndGreets.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: creativeMediaIcon,
    isImage: true,
    key: 'creativeMedia',
    title: intl.formatMessage({ id: 'ExploreServices.CreativeMedia.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.CreativeMedia.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.CreativeMedia.linkName' }),
    linkDestination: 'SearchPage',
  },
  // {
  //   icon: 'money',
  //   key: 'appearances',
  //   title: intl.formatMessage({ id: 'ExploreServices.CustomRequest.title' }),
  //   description: intl.formatMessage({ id: 'ExploreServices.CustomRequest.description' }),
  //   linkName: intl.formatMessage({ id: 'ExploreServices.CustomRequest.linkName' }),
  //   linkDestination: 'SearchPage',
  // },
];

function Step({ step, onSelectService }) {
  return (
    <div className={css.block}>
      <div className={css.blockTopInfo}>
        <div className={css.icons} role="button" onClick={onSelectService}>
          {step?.isImage ? <img src={step?.icon} alt={step?.title} /> : <Icons name={step?.icon} />}
        </div>
        <h3>{step?.title}</h3>
        <p>{step?.description}</p>
      </div>
      <span role="button" onClick={onSelectService} className={css.findLink}>
        {step?.linkName} <Icons name="rightArrow" />{' '}
      </span>
    </div>
  );
}

function ExploreServices(props) {
  const { intl, isMobileLayout, onSelectService = () => {}, publicData } = props;

  // Get all signature services
  const allSteps = getSignatureServices(intl);

  // Filter steps to only include services that exist in publicData
  const steps = allSteps.filter(
    step => publicData?.[step.key] && Object.keys(publicData[step.key]).length > 0
  );

  // If no steps are available after filtering, return null to avoid rendering the section
  if (!steps.length) {
    return null;
  }

  return (
    <div className={css.howItWorks}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              <FormattedMessage id="ListingPageExploreServices.title" />
            </h2>
            {/* <p className={css.sectionDescription}>
              <FormattedMessage id="ListingPageExploreServices.description" />
            </p>
            <ol className={css.sectionDescriptionList}>
              <li>
                <FormattedMessage id="ListingPageExploreServices.step1" />
              </li>
              <li>
                <FormattedMessage id="ListingPageExploreServices.step2" />
              </li>
            </ol> */}
          </div>
        </div>
        <div className={css.sectionContent}>
          <div className={css.featuredListingsContent}>
            <div className={css.templatesSlider}>
              {steps?.length > 1 ? (
                <Slider {...{ ...sliderSettings, arrows: isMobileLayout ? false : true }}>
                  {steps.map((step, index) => (
                    <Step
                      key={index}
                      step={step}
                      onSelectService={() => onSelectService(step?.key)}
                    />
                  ))}
                </Slider>
              ) : (
                <div className={css.singleSlider}>
                  <Step
                    key={steps[0]}
                    step={steps[0]}
                    onSelectService={() => onSelectService(steps[0]?.key)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Default slider settings
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
  ],
};

ExploreServices.defaultProps = {
  sliderSettings,
};

export default ExploreServices;
